<template>
  <div v-if="field">
    <p class="ma-0" v-html="replaceEnters(field.value)"></p>

    <v-dialog v-model="editting" width="500">
      <v-btn slot="activator" v-if="user" color="secondary" dark>Bewerken</v-btn>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Bewerk veld</v-card-title>

        <v-card-text>
          <v-textarea id="editor" autofocus solo v-model="newValue"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="editting = false">Annuleren</v-btn>

          <v-btn color="primary" @click="save()">Opslaan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    fieldId: {
      required: true
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    fields() {
      return this.$store.getters.fields;
    }
  },
  data() {
    return {
      editting: false,
      field: null,
      newValue: null
    };
  },
  methods: {
    async save() {
      try {
        // let val = document.getElementById("editor").children[0].innerHTML;
        let val = this.newValue;
        await this.$store.dispatch("setField", {
          id: this.field.id,
          value: val
        });
        this.field.value = val;
        this.editting = false;
      } catch (err) {
        console.log(err);
      }
    },
    replaceEnters(str) {
      if (str) {
        return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    }
  },
  created() {
    if (this.fields && this.fieldId) {
      this.field = this.fields.find(x => x.id === this.fieldId);

      if (this.field) {
        this.newValue = this.field.value;
      }
    }
  }
};
</script>

<style>
#editor {
  height: 300px;
}
</style>
